import React, {ChangeEvent, FormEvent, MouseEvent, useEffect, useRef, useState} from "react";
import * as _ from "lodash";

import {DashboardCategory} from "../Dashboard/Category";

import {Spinner, Button, Dropdown, Modal, Form, Row, Col, OverlayTrigger, Tooltip} from "react-bootstrap";
import { Utils } from "@/common/utils";
import {DragDropContext, Draggable, Droppable, DropResult} from "react-beautiful-dnd";
import {Grid2x2} from "lucide-react";
import { DashboardCard } from "./Card";
import DebouncedInput from "Components/Common/DebouncedInput";
import {ALL_DASHBOARDS, FAVORITE_DASHBOARDS} from "../../../utils/constans";
import ExternalLinkIcon from "Components/Icons/ExternalLinkIcon";
import HelpIcon from "Components/Icons/HelpIcon";
import PlusBlack from "Components/Icons/PlusBlack";
import SearchDashboardsIcon from "Components/Icons/SearchDashboards";
import SortDashboardsIcon from "Components/Icons/SortDashboardsIcon";
import SortDashboardsSolidIcon from "Components/Icons/SortDashboardsSolidIcon";
import ListBlackDash from "Components/Icons/ListBlackDash";
import {CreatableWrapper, SelectWrapper} from "Components/Common/SelectWrapper";
import {SimpleCheckbox} from "Components/Common/SimpleCheckbox";
import {DashboardCategoryDict, useDashboardsInCategories, Dashboard as DashboardType} from "@/hooks/dashboard";
import {useFeatureGatingEnabled} from "@/hooks/feature-gating";
import {useAppContext} from "@/contexts/app";
import {EAIClient} from "Services/EAIClient";
import PageTitle from "Components/Common/PageTitle";
import {useQuery} from "@/hooks/router";
import { useToast } from "@/hooks/useToast";
import { TanDashboardList } from "./TanDashboardList";

export type orderCategories = "group" | "name asc" | "name desc" | "custom_order";
export type dashboardOrder = {dashboard_id: string | number, custom_order: number};

interface DashboardTypeOption {
    label: string
    value: string
    url: string
}

const dashboardTypeOptions: readonly DashboardTypeOption[] = [
    {label: "Tableau", value: "tableau", url: ""},
    {label: "Power BI", value: "power_bi", url: ""},
    {label: "Google Spreadsheet", value: "google_spreadsheet", url: ""},
    {label: "Google Doc", value: "google_doc", url: ""},
    {label: "Youtube", value: "youtube", url: ""},
    {label: "SharePoint", value: "sharepoint", url: ""},
    {label: "Other", value: "other", url: ""}
];

interface DashboardGroupOption {
    readonly label: string;
    readonly value: string;
}

export function DashboardList() {
    const [orderBy, setOrderBy] = useState("group");
    const {data: dashboardsInCategories, dataFlat: dashboards, dataFavorites, byoDashboards, mutate} = useDashboardsInCategories(false, false, true, null, orderBy as orderCategories);
    const {enabled: byoEnabled} = useFeatureGatingEnabled("ui", "byo_dashboard");
    const [customize, setCustomize] = useState(false);
    const [filterValue, setFilterValue] = useState("");
    const [custom_order, setCustomOrder] = useState<dashboardOrder[]>([]);
    const [dashboards_custom, setDashboardsCustom] = useState<DashboardType[]>([]);
    const [showByoModal, setShowByoModal] = useState(false);
    const [showByoPreviewModal, setShowByoPreviewModal] = useState(false);
    const [selectedDashboard, setSelectedDashboard] = useState<DashboardType | null>(null);
    const [dashboard_grouped, set_dashboard_grouped] = useState<DashboardCategoryDict>({});
    const [byoDashboardName, setByoDashboardName] = useState("");
    const [byoDashboardDescription, setByoDashboardDescription] = useState("");
    const [byoDashboard, setByoDashboard] = useState("");
    const [byoDashboardGroup, setByoDashboardGroup] = useState<DashboardGroupOption | null>(null);
    const [byoDashboardType, setByoDashboardType] = useState<DashboardTypeOption>(dashboardTypeOptions[0]);
    const [byoPublicCanView, setByoPublicCanView] = useState(false);
    const [byoFacultyCanView, setByoFacultyCanView] = useState(false);
    const [byoMentorCanView, setByoMentorCanView] = useState(false);
    const [byoAdminsCanView, setByoAdminsCanView] = useState(true);
    const [byoImage, setByoImage] = useState<string | null>(null);
    const [showThumbnailPreview, setShowThumbnailPreview] = useState(false);
    const [byoDashboardGroupsOptions, setByoDashboardGroupsOptions] = useState<DashboardGroupOption[]>([]);
    const [byoIsDuplicated, setByoIsDuplicated] = useState(false);
    const [isSavingByoDashboard, setIsSavingByoDashboard] = useState(false);
    const [isDashboardProcessing, setIsDashboardProcessing] = useState(false);
    const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
    const inputRef = useRef<HTMLInputElement>(null);
    const {dispatchError} = useAppContext();
    const query = useQuery();
    const client = new EAIClient();
    const { toast } = useToast();
    const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
    const listButtonRef = useRef<HTMLButtonElement>(null);
    const gridButtonRef = useRef<HTMLButtonElement>(null);

    // Deduplicate dashboards by ID at the source before rendering any dashboard lists
    const dedupedDashboards = _.uniqBy(dashboards, "id");


    const handleOrderBy = async (category: orderCategories) =>{
        setOrderBy(category);
        mutate();
    };

    const checkIfIsFavorite = (dashboard_id: number) => {
        for (const category in dashboardsInCategories) {
            if (dashboardsInCategories.hasOwnProperty(category)) {
                const isFavoriteDashboards = category === FAVORITE_DASHBOARDS;
                const orIsCustomOrder = category === ALL_DASHBOARDS;
                if (isFavoriteDashboards ){
                    const dashboardsInCategory = dashboardsInCategories[category];
                    if (dashboardsInCategory.some(dash => dash && dash.id === dashboard_id)) {
                        return true;
                    }
                } else if (orIsCustomOrder) {
                    if (dataFavorites && dataFavorites.some(favDash => favDash.id === dashboard_id)) {
                        return true;
                    }
                }
            }
        }
        return false;
    };

    const setFilterValueHandler = (value: string) => {
        const lowerCaseValue = value.toLowerCase();
        const filteredResults: DashboardCategoryDict = {};

        for (const key in dashboardsInCategories) {
            if (dashboardsInCategories.hasOwnProperty(key)) {
                const dashboards = dashboardsInCategories[key];
                let filteredDashboards: DashboardType[] = [];

                filteredDashboards = dashboards.filter((dashboard) => {
                    const match = (
                        dashboard.category?.toLowerCase().includes(lowerCaseValue) ||
                        dashboard.name.toLowerCase().includes(lowerCaseValue)
                    );
                    return match;
                });

                if (filteredDashboards.length > 0) {
                    filteredResults[key] = filteredDashboards;
                }
            }
        }
        setFilterValue(value);
        set_dashboard_grouped(filteredResults);
    };

    const onClickCustomize = () => {
        handleOrderBy("custom_order");
        const new_custom_order = dashboards.map((item, index) => ({
            dashboard_id: item.id,
            custom_order: index,
        }));
        setCustomize(true);
        setCustomOrder(new_custom_order);
        setDashboardsCustom(dashboards);
    };

    const onDragEnd = (e: DropResult) => {
        const new_order = {
            dashboard_id: Number(e.draggableId),
            custom_order: Number(e.destination?.droppableId)
        };
        const newArray = [...custom_order];
        newArray.splice(Number(e.destination!.droppableId), 0, new_order);
        const filteredArray = newArray.filter(
            item => item.dashboard_id !== new_order.dashboard_id || item.custom_order === new_order.custom_order
        );

        const updatedArray = filteredArray.map((item, index) => ({
            ...item,
            custom_order: index
        }));

        const lookup = updatedArray.reduce((acc, obj) => {
            acc[obj.dashboard_id] = obj.custom_order;
            return acc;
        }, {});

        // Iterate through this.state.dashboards_custom and replace custom_order if ID matches in updatedArray
        const newCustomArray = dashboards_custom.map((obj) => {
            const customOrderFromArr2 = lookup[obj.id];
            if (customOrderFromArr2 !== undefined) {
                // If the ID is found, replace the custom_order
                return { ...obj, custom_order: customOrderFromArr2 };
            }
            return obj;
        });
        setDashboardsCustom(newCustomArray);
        setCustomOrder(updatedArray);
    };

    const byoIsValid = () => {
        return byoDashboardName.length > 0 && byoDashboardGroup && byoDashboard.length > 0 && !byoIsDuplicated;
    };

    const getDefaultIcon = () => {
        switch (byoDashboardType.value) {
            case "tableau":
                return "https://enflux-static-prod.s3.amazonaws.com/byodashboards/tableau.png";
            case "power_bi":
                return "https://enflux-static-prod.s3.amazonaws.com/byodashboards/power_bi.png";
            case "google_spreadsheet":
                return "https://enflux-static-prod.s3.amazonaws.com/byodashboards/google-sheets-icon-300x284.jpg";
            case "google_doc":
                return "https://enflux-static-prod.s3.amazonaws.com/byodashboards/Google_Docs_logo.svg";
            case "youtube":
                return "https://enflux-static-prod.s3.amazonaws.com/byodashboards/yt_icon_rgb.png";
            case "sharepoint":
                return "https://enflux-static-prod.s3.amazonaws.com/byodashboards/sharepoint.png";
            default:
                return "https://enflux-static-prod.s3.amazonaws.com/dash_thumbs/DefaultBYODashboard.png";
        }
    };

    const handleByoDismiss = () => {
        setShowByoModal(false);
        setSelectedDashboard(null);
    };

    const handleByoSubmit = async (ev: FormEvent<HTMLFormElement> | MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault();
        setIsSavingByoDashboard(true);
        const isUrl = Utils.isUrl(byoDashboard);
        let embeddedCode;
        if (!isUrl) {
            embeddedCode = Utils.encodeBase64(byoDashboard);
        }
        const data: Partial<DashboardType> = {
            name: byoDashboardName,
            description: `<div>${byoDashboardDescription}</div>`,
            url: isUrl ? byoDashboard : undefined,
            category: byoDashboardGroup?.value,
            status: "enabled",
            short_name: byoDashboardName,
            workbook_name: `BYOContent: ${byoDashboardName}`,
            public_can_view: byoPublicCanView,
            faculty_can_view: byoFacultyCanView,
            mentors_can_view: byoMentorCanView,
            admins_can_view: byoAdminsCanView,
            dashboard_type: "BYODashboard",
            use_url: isUrl,
            embedded_code: isUrl ? undefined : embeddedCode,
            byo_dashboard_type: byoDashboardType?.value
        };
        if (!inputRef || !inputRef.current) {
            let defaultIcon = getDefaultIcon();
            if (byoDashboardType.value === "youtube") {
                const youtubeId = Utils.getYoutubeId(byoDashboard);
                if (youtubeId) {
                    defaultIcon = `https://i4.ytimg.com/vi/${youtubeId}/0.jpg`;
                }
            }
            data.thumbnail_url_300 = defaultIcon;
            data.thumbnail_url_600 = defaultIcon;
        } else if (showThumbnailPreview) {
            let newThumbnailIcon = getDefaultIcon();
            if (byoDashboardType.value === "youtube") {
                const youtubeId = Utils.getYoutubeId(byoDashboard);
                if (youtubeId) {
                    newThumbnailIcon = `https://i4.ytimg.com/vi/${youtubeId}/0.jpg`;
                }
            }
            data.thumbnail_url_300 = newThumbnailIcon;
            data.thumbnail_url_600 = newThumbnailIcon;
        }
        try {
            if (selectedDashboard) {
                // update
                data.id = selectedDashboard.id;
                await client.updateBYOCDashboard(data);
                toast({
                    type: "success",
                    title: "Dashboard Updated",
                    message: `Dashboard \"${byoDashboardName}\" has been successfully updated. (Category: ${byoDashboardGroup?.value || "Uncategorized"})`
                });
            } else {
                // create
                await client.addBYOCDashboard(data);
                toast({
                    type: "success",
                    title: "Dashboard Published",
                    message: `Dashboard \"${byoDashboardName}\" has been successfully added to group ${byoDashboardGroup?.value || "Uncategorized"}`
                });
            }
        } catch (error) {
            dispatchError(error);
            return;
        }

        // create thumbnail
        if (inputRef && inputRef.current && inputRef.current.files && inputRef.current.files[0]) {
            const formData = new FormData();
            formData.append(
                "file",
                inputRef.current.files[0]
            );
            try {
                await client.updateDashboardThumbnail(`BYOContent: ${byoDashboardName}`, formData);
            } catch (error) {
                dispatchError(error);
            }
        }

        setShowByoModal(false);
        setIsSavingByoDashboard(false);
        handleOrderBy(orderBy as orderCategories);
    };

    const handleEditClick = (resource: DashboardType) => {
        const description = resource.description.replace("<div>", "").replace("</div>", "");
        const selectedDashboardType = dashboardTypeOptions.find(dashboardType => dashboardType.value === resource.byo_dashboard_type);
        const selectedDashboardGroup: DashboardGroupOption | null = resource.category ? {label: resource.category, value: resource.category} : null;
        let byoDashboardValue = "";
        if (resource.use_url) {
            byoDashboardValue = resource.url;
        } else {
            byoDashboardValue = resource.embedded_code ? resource.embedded_code : "";
        }
        setSelectedDashboard(resource);
        setByoDashboardName(resource.name);
        setByoDashboardDescription(description);
        setByoDashboard(byoDashboardValue);
        setByoDashboardType(selectedDashboardType ?? dashboardTypeOptions[0]);
        setByoDashboardGroup(selectedDashboardGroup);
        setByoPublicCanView(resource.public_can_view ?? false);
        setByoFacultyCanView(resource.faculty_can_view ?? false);
        setByoMentorCanView(resource.mentors_can_view ?? false);
        setByoAdminsCanView(resource.admins_can_view ?? true);
        setByoIsDuplicated(false);
        setByoImage(resource.thumbnail_url_300);
        setShowThumbnailPreview(false);
        setShowByoModal(true);
        if (inputRef && inputRef.current) {
            inputRef.current.files = null;
        }
    };

    const handleCreateClick = () => {
        setSelectedDashboard(null);
        setByoDashboardName("");
        setByoDashboardDescription("");
        setByoDashboard("");
        setByoDashboardGroup(null);
        setByoDashboardType(dashboardTypeOptions[0]);
        setByoPublicCanView(false);
        setByoFacultyCanView(false);
        setByoMentorCanView(false);
        setByoAdminsCanView(true);
        setByoImage(null);
        setByoIsDuplicated(false);
        setShowThumbnailPreview(false);
        setShowByoModal(true);
        if (inputRef && inputRef.current) {
            inputRef.current.value = "";
        }
    };

    const handleByoDashboardNameChange = (ev: ChangeEvent<HTMLInputElement>) => {
        if (ev.target.value.length < 45) {
            setByoDashboardName(ev.target.value);
        }
        const found = byoDashboards.find(dashboard => dashboard.name === ev.target.value);
        if (found && selectedDashboard) {
            setByoIsDuplicated(found.id !== selectedDashboard.id);
            return;
        }
        setByoIsDuplicated(!!found);
    };

    const handleByoDashboardDescriptionChange = (ev: ChangeEvent<HTMLInputElement>) => {
        setByoDashboardDescription(ev.target.value);
    };

    const handleDashboardTypeChange = (next: DashboardTypeOption) => {
        setShowThumbnailPreview(true);
        setByoDashboardType(next);
        if (inputRef && inputRef.current) {
            inputRef.current.value = "";
        }
    };

    const handleShowPreview = () => {
        setShowByoModal(false);
        setShowByoPreviewModal(true);
    };

    const getThumbnailPreviewIcon = () => {
        if (showThumbnailPreview) {
            return getDefaultIcon();
        }

        return byoImage || getDefaultIcon();
    };

    const handleOnlyAdminsCanViewChange = (next: boolean) => {
        setByoAdminsCanView(next);
        if (next) {
            setByoFacultyCanView(false);
            setByoMentorCanView(false);
            setByoPublicCanView(false);
        }
    };

    const handleAdminsAndOthersCanViewChange = (next: boolean) => {
        if (next) {
            setByoAdminsCanView(true);
            setByoFacultyCanView(true);
            setByoMentorCanView(true);
            setByoPublicCanView(true);
        } else {
            setByoFacultyCanView(false);
            setByoMentorCanView(false);
            setByoPublicCanView(false);
        }
    };

    const handleFacultyCanViewChange = (next: boolean) => {
        setByoFacultyCanView(next);
    };

    const handleMentorCanViewChange = (next: boolean) => {
        setByoMentorCanView(next);
    };

    const handlePublicCanViewChange = (next: boolean) => {
        setByoPublicCanView(next);
    };

    const handleDismissPreview = () => {
        setShowByoPreviewModal(false);
        setShowByoModal(true);
    };

    const handleDashboardDelete = (dashboardName: string, dashboardCategory?: string) => {
        toast({
            type: "info",
            title: "Content Deleted",
            message: `Dashboard \"${dashboardName}\" has been successfully deleted. (Category: ${dashboardCategory || "Uncategorized"})`
        });
        handleOrderBy(orderBy as orderCategories);
    };

    const renderList = () => {
        const categories: JSX.Element[] = [];
        Object.entries(dashboard_grouped).forEach(([cat, dash]) => {
            const isFavorite = cat === FAVORITE_DASHBOARDS;
            const categoryElement = (
                <DashboardCategory
                    onClickEdit={handleEditClick}
                    onClickDelete={handleDashboardDelete}
                    cards={dash}
                    name={cat}
                    favorites={dataFavorites ?? []}
                    categories={dashboardsInCategories}
                    orderBy={orderBy as orderCategories}
                    mutate={mutate}
                    key={`${cat}-`}
                    viewMode={viewMode}
                />
            );
            if (isFavorite) {
                categories.unshift(categoryElement); // Add Favorite Dashboards to the beginning
            } else {
                categories.push(categoryElement);
            }
        });
        const isCategoryFavoriteExists = categories.some((dash) => dash.key?.toString().slice(0,-1) === FAVORITE_DASHBOARDS );
        if(!isCategoryFavoriteExists && categories.length !== 0 && orderBy !== "custom_order"){
            categories.splice(
                0, 0,
                <DashboardCategory
                    onClickEdit={handleEditClick}
                    onClickDelete={() => {}}
                    cards={dedupedDashboards}
                    name={FAVORITE_DASHBOARDS}
                    favorites={dataFavorites ?? []}
                    categories={dashboardsInCategories}
                    mutate={mutate}
                    orderBy={orderBy as orderCategories}
                    key={`${FAVORITE_DASHBOARDS}-`}
                    viewMode={viewMode}
                />);
        } else if (!isCategoryFavoriteExists && categories.length === 0) {
            return <p className="no-favorites-text">No matches found.</p>;
        }
        return categories;
    };

    useEffect(() => {
        if (dashboardsInCategories) {
            set_dashboard_grouped(dashboardsInCategories);
            const categories: DashboardGroupOption[] = Object.keys(dashboardsInCategories)
                .filter(category => category !== "FAVORITE DASHBOARDS")
                .map(category => ({label: category, value: category}));
            setByoDashboardGroupsOptions(categories);
        }
    }, [dashboardsInCategories]);

    useEffect(() => {
        if (dashboards && dashboards.length !== dashboards_custom.length) {
            setDashboardsCustom(dashboards);
        }
    }, [dashboards]);

    useEffect(() => {
        const dashboardGroup = query.get("dashboardGroup");
        if (dashboardGroup && dashboardsInCategories) {
            // search for id "dashboardGroup" and scroll to the element
            setTimeout(() => {
                const element = document.getElementById(dashboardGroup);
                if (element) {
                    const y = element.getBoundingClientRect().top + window.scrollY - 25;
                    window.scrollTo({top: y, behavior: "smooth"});
                }
            }, 350);
        }
    }, [query, dashboardsInCategories]);

    // Persist viewMode in localStorage
    useEffect(() => {
        const savedViewMode = localStorage.getItem("dashboardViewMode");
        if (savedViewMode === "list" || savedViewMode === "grid") {
            setViewMode(savedViewMode);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem("dashboardViewMode", viewMode);
    }, [viewMode]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (document.activeElement === listButtonRef.current || document.activeElement === gridButtonRef.current) {
                if (e.key === "ArrowRight") {
                    e.preventDefault();
                    if (gridButtonRef.current) {
                        gridButtonRef.current.focus();
                    }
                    setViewMode("grid");
                } else if (e.key === "ArrowLeft") {
                    e.preventDefault();
                    if (listButtonRef.current) {
                        listButtonRef.current.focus();
                    }
                    setViewMode("list");
                } else if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    if (document.activeElement === listButtonRef.current) {
                        setViewMode("list");
                    } else {
                        setViewMode("grid");
                    }
                }
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [setViewMode]);

    const renderByoModalForm = () => {
        return (
            <>
                <Modal.Header>
                    <p className="w-100">{selectedDashboard ? "Edit BYOContent" : "Create BYOContent"}
                        <a target="_blank" rel="noreferrer"
                           href="https://knowledgebase.enflux.com/en/bring-your-own-dashboards"
                           className="float-end fw-bold color-primary">Knowledge Base <ExternalLinkIcon/></a></p>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleByoSubmit}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">
                                Name
                                <OverlayTrigger
                                    overlay={<Tooltip className="custom-tooltip">Enter a descriptive name for your content. This will be displayed as the title and should be easily identifiable.</Tooltip>}>
                                    <span className="ms-1"><HelpIcon /></span>
                                </OverlayTrigger>
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control type="text" required={true} onChange={handleByoDashboardNameChange} value={byoDashboardName} />
                                {byoIsDuplicated && (
                                    <Form.Text className="text-muted">
                                        You already have a dashboard with this name.
                                    </Form.Text>
                                )}
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">
                                Description
                                <OverlayTrigger
                                    overlay={<Tooltip className="custom-tooltip">Provide a concise summary of your content and purpose. This helps others understand what kind of information your content presents.</Tooltip>}>
                                    <span className="ms-1"><HelpIcon /></span>
                                </OverlayTrigger>
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control type="text" as="textarea" rows={2} onChange={handleByoDashboardDescriptionChange} value={byoDashboardDescription} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">
                                Dashboard Group
                                <OverlayTrigger
                                    overlay={<Tooltip id="tooltip-dashboard-group-helper" className="custom-tooltip">Select an existing group to categorize your content, or Type and hit 'Enter' to create a new dashboard group. Groups help organize content by similar functions or departments.</Tooltip>}>
                                    <span className="ms-1"><HelpIcon /></span>
                                </OverlayTrigger>
                            </Form.Label>
                            <Col sm="9">
                                <CreatableWrapper<DashboardGroupOption>
                                    onChange={newGroup => setByoDashboardGroup(newGroup)}
                                    options={byoDashboardGroupsOptions}
                                    value={byoDashboardGroup}
                                    placeholder="Select Dashboard Group"
                                />

                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">
                                Content Type
                                <OverlayTrigger
                                    overlay={<Tooltip id="tooltip-dashboard-type-helper" className="custom-tooltip">Choose the type of content you're creating. This should match the service where your content is hosted, like Tableau or PowerBI.</Tooltip>}>
                                    <span className="ms-1"><HelpIcon /></span>
                                </OverlayTrigger>
                            </Form.Label>
                            <Col sm="9">
                                <SelectWrapper
                                    classNamePrefix="dashboard-type-select"
                                    onChange={handleDashboardTypeChange}
                                    options={dashboardTypeOptions}
                                    value={byoDashboardType}
                                />
                            </Col>
                        </Form.Group>
                        <Row className="">
                            <Form.Group as={Col}>
                                <Form.Label>
                                    Content Embedded Code or URL
                                    <OverlayTrigger
                                        overlay={<Tooltip id="tooltip-embedded-helper" className="custom-tooltip">Paste the embed code or URL for your content here. Make sure the link is accessible to all intended users and the content is set to the correct privacy settings.</Tooltip>}>
                                        <span className="ms-1"><HelpIcon /></span>
                                    </OverlayTrigger>
                                </Form.Label>
                                <Form.Control as="textarea" required={true} onChange={event => setByoDashboard(event.target.value)} placeholder="Insert Embedded Code or URL" value={byoDashboard} rows={3} />
                                <p className="text-end mt-1 mb-0">
                                    <Button size="sm" disabled={byoDashboard.length === 0} onClick={handleShowPreview}>Preview</Button>
                                </p>
                            </Form.Group>
                        </Row>
                        <Row className="mb-1">
                            <Col>
                                Content Thumbnail
                            </Col>
                        </Row>
                        <div className="border py-2 px-1 rounded-2 mb-3">
                            <Row>
                                <Col>
                                    <div className="image-picker" style={{ width: "100%", display: "flex" }}>
                                        <div style={{ width: "11%", textAlign: "center" }}>
                                            <p className="mb-0 text-muted">
                                                Default
                                            </p>
                                            <img height="60px"
                                                style={{ border: "1px solid #ddd", borderRadius: "5px" }}
                                                alt="Enflux thumbnail"
                                                src={getThumbnailPreviewIcon()} />
                                        </div>
                                        <div style={{ width: "5%", margin: "auto", textAlign: "center" }}>
                                            <p className="mb-0">OR</p>
                                        </div>
                                        <div style={{ width: "84%", display: "flex", alignItems: "center" }}>
                                            <div className="ps-3">
                                                <div style={{ display: "flex" }}>
                                                    <input className="ms-3" type="file" ref={inputRef} name="thumbnail" style={{ flex: "8" }}
                                                        accept="image/png, image/jpeg, image/svg+xml" />
                                                    <OverlayTrigger
                                                        placement="right"
                                                        overlay={<Tooltip id="tooltip-default" className="custom-tooltip">Upload image that represents your content.
                                                            This image will be displayed as a thumbnail or when the dashboard content cannot be loaded.
                                                        </Tooltip>}
                                                        popperConfig={{
                                                            modifiers: [
                                                                {
                                                                    name: 'offset',
                                                                    options: {
                                                                        offset: [24, 8],
                                                                    },
                                                                },
                                                            ],
                                                        }}>
                                                        <span className="ms-1" style={{ flex: "2", cursor: "pointer" }}><HelpIcon /></span>
                                                    </OverlayTrigger>
                                                </div>
                                                <p className="ms-3 mb-0 font-small">Note: This image will be publicly available</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <Row className="mb-1">
                            <Col>
                                Who can view in Enflux
                            </Col>
                        </Row>
                        <div className="border py-2 px-5 rounded-2">
                            <Row className="mb-1">
                                <Col>
                                    <SimpleCheckbox
                                        isChecked={byoAdminsCanView && !byoFacultyCanView && !byoMentorCanView && !byoPublicCanView}
                                        onChange={handleOnlyAdminsCanViewChange} id="selected-public-can-view" label="Only Admins" />
                                </Col>
                            </Row>
                            <Row className="">
                                <Col>
                                    <SimpleCheckbox
                                        isChecked={byoAdminsCanView && byoFacultyCanView && byoMentorCanView && byoPublicCanView}
                                        onChange={handleAdminsAndOthersCanViewChange} id="selected-faculty-can-view" label="Admins and others" />
                                    <ul style={{listStyleType: "none"}} className="mb-0">
                                        <li>
                                            <SimpleCheckbox isChecked={byoFacultyCanView} onChange={handleFacultyCanViewChange} id="selected-faculty-can-view" label="Faculty - People assigned courses" />
                                        </li>
                                        <li>
                                            <SimpleCheckbox isChecked={byoMentorCanView} onChange={handleMentorCanViewChange} id="selected-mentors-can-view" label="Mentors - People assigned to students" />
                                        </li>
                                        <li>
                                            <SimpleCheckbox isChecked={byoPublicCanView} onChange={handlePublicCanViewChange} id="selected-all-users-can-view" label="All Users" />
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleByoDismiss}>Close</Button>
                    <Button variant="primary" onClick={handleByoSubmit} type="submit" disabled={!byoIsValid() || isSavingByoDashboard}>{isSavingByoDashboard ? "Saving" : "Save"}</Button>
                </Modal.Footer>
            </>
        );
    };

    return (
        <>
            <PageTitle pageTitle="All Dashboards" />
            <div className="nav-order-dashboards">
                {customize ?
                    <div>
                        <div className="saveOrder">
                            Drag and drop to customize the order of the boards.
                            <Button
                                id="saveOrder"
                                disabled={isDashboardProcessing}
                                onClick={async () => {
                                    try {
                                        setIsDashboardProcessing(true);
                                        await client.updateDashboardOrder(custom_order);
                                    } catch (e) {
                                        dispatchError(e);
                                    }
                                    setCustomize(false);
                                    handleOrderBy("custom_order");
                                    setIsDashboardProcessing(false);
                                }}
                            >
                                Save order
                            </Button>
                        </div>
                    </div> : !dashboardsInCategories ?
                    <div style={{textAlign: "center", paddingTop: 80}}>
                        <Spinner animation="border" variant="secondary" />
                    </div> : null}

                { dashboardsInCategories && !customize &&
                    <div className="orderByDiv">
                        <div className="orderByHeaderRow border-bottom">
                            <span className="dashboardTitle">All Dashboards</span>
                            <div className="addDashboard">{byoEnabled && Utils.hasAdminAccess() && (
                                <Button
                                    className="me-3 addDashboardButton"
                                    onClick={handleCreateClick}>
                                    <PlusBlack/>Add content
                                </Button>
                            )}</div>
                        </div>

                    <div className="orderByControlsRow border-bottom">
                        <div className="iconInput">
                            <SearchDashboardsIcon/>
                            <DebouncedInput
                                type="text"
                                value={filterValue}
                                onChange={(value) => setFilterValueHandler(value.toString())}
                                placeholder="Search by group name or dashboard name"
                                className="searchInput"
                            />
                        </div>

                        {orderBy === "custom_order" && (
                            <Button id="customizeOrder" onClick={onClickCustomize} className="customizeOrder">
                                Customize order
                            </Button>
                        )}

                            <div
                                className="orderBySortButton"
                                role="button"
                                tabIndex={0}
                                style={{ display: "flex", alignItems: "center", minWidth: 40, minHeight: 32 }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const dropdownToggle = document.querySelector(".orderByDropdown .dropdown-toggle");
                                    if (dropdownToggle) {
                                        (dropdownToggle as HTMLElement).click();
                                    }
                                    setSortDropdownOpen((prev) => !prev);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        const dropdownToggle = document.querySelector(".orderByDropdown .dropdown-toggle");
                                        if (dropdownToggle) {
                                            (dropdownToggle as HTMLElement).click();
                                        }
                                        setSortDropdownOpen((prev) => !prev);
                                    }
                                }}
                            >
                                <Dropdown
                                    drop="down-centered"
                                    className="orderByDropdown"
                                    onToggle={(isOpen) => setSortDropdownOpen(isOpen)}
                                >
                                    <Dropdown.Toggle
                                        className="customizeOrder no-style-toggle d-flex align-items-center"
                                        aria-label={`Sort by: ${orderBy === "custom_order"
                                                ? "Customized"
                                                : orderBy === "name asc"
                                                    ? "Name A-Z"
                                                    : orderBy === "name desc"
                                                        ? "Name Z-A"
                                                        : _.capitalize(orderBy)
                                            }`}
                                    >
                                        {sortDropdownOpen ? <SortDashboardsSolidIcon /> : <SortDashboardsIcon />}
                                        <p style={{ margin: "0px 4px 0px 4px" }}>Sort by: </p>
                                        <span>
                                            {orderBy === "custom_order"
                                                ? "Customized"
                                                : orderBy === "name asc"
                                                    ? "Name A-Z"
                                                    : orderBy === "name desc"
                                                        ? "Name Z-A"
                                                        : _.capitalize(orderBy)}
                                        </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleOrderBy("group")}>Group</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleOrderBy("name asc")}>Name A-Z</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleOrderBy("name desc")}>Name Z-A</Dropdown.Item>
                                        {Utils.hasAdminAccess() ? <Dropdown.Item onClick={() => handleOrderBy("custom_order")}>Customized</Dropdown.Item> : null}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                            <div className="orderByViewToggle" role="group" aria-label="View mode toggle">
                                <button
                                    type="button"
                                    ref={listButtonRef}
                                    className={`sortButton ${viewMode === "list" ? "active" : ""}`}
                                    onClick={() => setViewMode("list")}
                                    tabIndex={0}
                                    aria-label="Switch to List mode"
                                    aria-pressed={viewMode === "list"}
                                >
                                    <ListBlackDash />
                                    <p style={{ margin: 0 }}>List</p>
                                </button>
                                <button
                                    type="button"
                                    ref={gridButtonRef}
                                    className={`sortButton ${viewMode === "grid" ? "active" : ""}`}
                                    onClick={() => setViewMode("grid")}
                                    tabIndex={0}
                                    aria-label="Switch to Grid mode"
                                    aria-pressed={viewMode === "grid"}
                                >
                                    <Grid2x2 size={16} color="#292929" />
                                    <p style={{ margin: 0 }}>Grid</p>
                                </button>
                            </div>

                    </div>
                </div>}
            </div>

            {customize && (
                <div className="dashboard-dnd">
                    <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                        <div className="justify-content-center">
                            <div className="cards-wrapper">
                                <div className={`cards ${viewMode === "list" ? "list-view" : "grid-view"}`}>
                                {dashboards_custom
                                    ?.sort((a, b) => {
                                    if (a.custom_order === undefined) return 1;
                                    if (b.custom_order === undefined) return -1;
                                    return a.custom_order - b.custom_order;
                                    })
                                    .map((card, index) => (
                                    <Droppable droppableId={index.toString()} key={index}>
                                        {(provided) => (
                                        <div {...provided.droppableProps} ref={provided.innerRef}>
                                            <div key={card.name}>
                                            <Draggable draggableId={card.id.toString()} key={card.id} index={index}>
                                                {(provided) => (
                                                <div
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    ref={provided.innerRef}
                                                    className="card-wrapper"
                                                >
                                                    <DashboardCard
                                                    customize={true}
                                                    isFavorite={checkIfIsFavorite(card.id)}
                                                    dashboard={card}
                                                    key={card.name}
                                                    />
                                                </div>
                                                )}
                                            </Draggable>
                                            </div>
                                            {provided.placeholder}
                                        </div>
                                        )}
                                    </Droppable>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </DragDropContext>
                </div>
            )}
            {/* Dedicated layout for list view */}
            {dashboardsInCategories && !_.isEmpty(dashboardsInCategories) && !customize && viewMode === "list" ? (
                <div className="dashboard-list-view-wrapper">
                    <TanDashboardList
                        cards={dedupedDashboards}
                        onClickEdit={handleEditClick}
                        onClickDelete={handleDashboardDelete}
                        onClickFavorite={dashboard_id => {
                            const dashboard = dashboards.find(card => card.id === dashboard_id);
                            const dashboardName = dashboard ? dashboard.name : "Dashboard";
                            const categoryName = dashboard ? dashboard.category : undefined;
                            if (checkIfIsFavorite(dashboard_id)) {
                                client.deleteFavoriteDashBoard(dashboard_id).then(() => {
                                    toast({
                                        type: "info",
                                        title: "Removed from Favorites",
                                        message: `Dashboard \"${dashboardName}\" has been successfully removed from your favorites. (Category: ${categoryName})`
                                    });
                                    mutate();
                                }).catch(dispatchError);
                            } else {
                                client.addFavoriteDashboard(dashboard_id).then(() => {
                                    toast({
                                        type: "success",
                                        title: "Added to Favorites",
                                        message: `Dashboard \"${dashboardName}\" has been successfully added to your favorites. (Category: ${categoryName})`
                                    });
                                    mutate();
                                }).catch(dispatchError);
                            }
                        }}
                        checkIfIsFavorite={checkIfIsFavorite}
                    />
                </div>
            ) : dashboardsInCategories && !_.isEmpty(dashboardsInCategories) && !customize && viewMode === "grid" ? (
                <div className="category-list">
                    {renderList()}
                </div>
            ) : dashboardsInCategories && _.isEmpty(dashboardsInCategories) && !customize && (
                <p className="no-favorites-text">No dashboards found.</p>
            )}
            <Modal show={showByoModal} centered onHide={handleByoDismiss} size="lg">
                {renderByoModalForm()}
            </Modal>
            <Modal show={showByoPreviewModal} onHide={handleDismissPreview} centered size="xl">
                <Modal.Body style={{height: "600px"}}>
                    {Utils.isUrl(byoDashboard) ? (
                        <iframe style={{width: "100%", height: "600px"}} src={byoDashboard}></iframe>
                    ) : (
                        <iframe style={{width: "100%", height: "600px"}} srcDoc={byoDashboard}></iframe>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleDismissPreview}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
